import HttpService from "@/common/ApiService";
import configuration from "@/../public/urlConfig.json";
import { Hotel } from "../url";
import vue from "vue";
const http = new HttpService(vue.prototype.$config.unauthorizedHotelFlight, {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token'
});
require("linqjs");
const factory = () => ({
});
export default {
    namespaced: true,
    state: factory(),
    mutations: {

    },
    getters: {

    },
    actions: {


        async GetVoucher(context, params) {

            const response = await http.Post(Hotel.VOUCHER_URL, params);

            return response.data.data;
        },
        async CreateVoucher(context, params) {

            const response = await http.Post(Hotel.CREATEVOUCHER_URL, params);

            return response.data.data;
        },
        async GetHotelList() {

            const response = await http.Get('BaseInfo/GetHotelList');
            return response.data.data;
        },

        async GetDestinationList() {

            const response = await http.Get('BaseInfo/GetDestinationsInfo');
            return response.data.data;
        },
        async GetDariushHotelNewsList() {

            const response = await http.Get('Hotel/GetDariushHotelNews');
            return response.data.data;
        },
        async Cities(context) {
            const items = (await http.Get("/Location/GetLocations"))
                .data.select(t => t);

            context.commit("SetCities", items);
            return items;
        },
        async getLocations(context) {


            const items = (await http.Get("/Location/GetLocations"))
            // context.commit('SetLocations', items.data);
            return items.data;


        },
    }
}